import axios from 'axios';
import { Message } from 'element-ui';
import router from '../router';
//导入JSONbig
import JSONbig from 'json-bigint'

const $http = axios.create( {
	baseURL: 'http://82.157.35.13:2006',
	// baseURL: 'http://192.168.0.138:2006',
	timeout: 50000,
	transformResponse: [function(data) {
		try {
			// 作用1：把json字符串转为js对象
			// 作用2：把里面的大数字做安全处理
			return JSONbig.parse(data)
		} catch (e) {
			return data
		}
	}],
} );

$http.interceptors.request.use( config => {
	const token = sessionStorage.getItem( 'cloud_login_token' );

	// 判断token是否存在
	if ( token ) {
		config.headers.Authorization = token;
		// config.headers.Authorization = token
	}
	return config;
} );
// 响应拦截器
$http.interceptors.response.use(res => 
	{
		if ( res.data.code == 2003 ) {
			sessionStorage.clear();
			Message.error( '登录失效,请重新登录!' );
			setTimeout( () => {
				router.push( '/' );
			}, 1200 );
		}
		return res.data;
	},error => {

		/***** 接收到异常响应的处理开始 *****/
		if ( error && error.response ) {
			switch ( error.response.status ) {
				case 400:
				error.message = '400:错误请求!';
				break;
				case 401:
				error.message = '2003:未授权,请重新登录!';
				break;
				case 403:
				error.message = '403:拒绝访问!';
				break;
				case 404:
				error.message = '404:请求错误,未找到该资源!';
				break;
				case 405:
				error.message = '405:请求方法未允许!';
				break;
				case 408:
				error.message = '408:请求超时!';
				break;
				case 500:
				error.message = '500:服务器端出错!';
				break;
				case 501:
				error.message = '501:网络未实现!';
				break;
				case 502:
				error.message = '502:网络错误!';
				break;
				case 503:
				error.message = '503:服务不可用!';
				break;
				case 504:
				error.message = '504:网络超时!';
				break;
				case 505:
				error.message = '505:http版本不支持该请求!';
				break;
				// default:error.message = `连接错误${error.response.status}`
			}
		} else {
			// 超时处理
			if ( JSON.stringify( error ).includes( 'timeout' ) ) {
				Message.error( '服务器响应超时,请刷新当前页!' );
			}
			error.message = '连接服务器失败!';
		}
		// Message.error(error.message)
		/***** 处理结束 *****/
		return Promise.resolve( error.response );
	}
);

export default $http;
